import { injectable } from 'inversify';

// tslint:disable: unified-signatures

const unpackers = {
    async 'application/json'(resp: Response) {
        return resp.json();
    },
    async 'image/svg+xml'(resp: Response) {
        return resp.text();
    },
    async 'text/plain'(resp: Response) {
        return resp.text();
    },
};

type ResourceHandler = (path: string) => ResourceInfo | undefined;

const handlerFromList = (pattern: RegExp, list: ResourceInfo[]): ResourceHandler => {
    const map = Object.fromEntries(list.map(x => [x.id, x]));
    return (path: string) => {
        pattern.lastIndex = 0;
        const match = pattern.exec(path);
        if (match) {
            return map[match[1]] ?? undefined;
        }
    };
};

const handlerFromBucket = (pattern: RegExp, bucketUrl: string): ResourceHandler =>
    (path: string) => {
        pattern.lastIndex = 0;
        const match = pattern.exec(path);
        if (match) {
            return {
                id: match[1],
                path: `${bucketUrl}${match[1]}.svg`,
                type: 'image/svg+xml',
            };
        }
    };

const handlers = [
    // handlerFromList(/^deqo:\/\/icons\/dash\/(.*)$/, DashIcons as any),
    // handlerFromList(/^deqo:\/\/icons\/deqo\/(.*)$/, DeqoIcons as any),
    // handlerFromList(/^deqo:\/\/icons\/d2\/(.*)$/, Deqo2cons as any),
    // handlerFromList(/^deqo:\/\/icons\/hero\/(.*)$/, HeroIcons as any),
    // handlerFromList(/^deqo:\/\/icons\/s2\/(.*)$/, Shape2cons as any),
    // handlerFromList(/^deqo:\/\/icons\/tokens\/(.*)$/, Tokens as any),
    handlerFromBucket(/^deqo:\/\/icons\/sln\/(.*)$/, 'https://s.ludi.co/icons/sln/'),
];

export interface ResourceInfo {
    id: string;
    type: keyof typeof unpackers;
    path: string;
}

@injectable()
export class ResourceManager {

    public async info(uri: string): Promise<ResourceInfo> {
        for (const h of handlers) {
            const info = h(uri);
            if (info) return Promise.resolve(info);
        }
        throw new Error(`ResourceManager: ${uri} could not be resolved.`);
    }

    public async fetch(uri: string, expectedType: 'application/json'): Promise<any>;

    public async fetch(uri: string, expectedType: 'image/svg+xml'): Promise<string>;

    public async fetch(uri: string, expectedType: 'text/plain'): Promise<string>;

    public async fetch(uri: string, expectedType: keyof typeof unpackers): Promise<any> {
        if (uri.startsWith('deqo://')) {
            return this.info(uri).then(({ path }) => path).then(fetchPath).then(unpackers[expectedType]);
        }
        else {
            return fetchPath(uri).then(unpackers[expectedType]);
        }
    }
}

const fetchPath = (path: string) =>
    fetch(path, {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
    });
